<template>
  <div class="sm-company-info">
    <div class="sm-wrap lg">
      <div class="sm-company-info-inner">
        <div class="sm-company-info__main">
          <div class="sm-company-info__main-left">
            <h3 v-if="provider.plan_layout && provider.plan_layout.header">{{provider.plan_layout.header}}</h3>
            <div 
              class="sm-company-info__main-left-address"
              @click="openMap"
            >
              <span v-if="provider.street">{{provider.street}}</span>
              <span>
                <template v-if="provider.city">{{provider.city}}, </template>
                <template v-if="state">{{state.code}} </template>
                <template v-if="provider.zip_code">{{provider.zip_code}} </template>
                <template v-if="country">{{country.name}}</template>
              </span>
            </div>
          </div>
          <div class="sm-company-info__main-right">
            <p
              v-if="provider.plan_layout && provider.plan_layout.sub_header"
              class="sm-lead"
            >{{provider.plan_layout.sub_header}}</p>
            <div class="sm-company-info__main-right-contacts">
              <div v-if="provider.voffice_hours">
                <include-svg svg :name="'icon-footer-clock'" />
                <span>Office hours</span>
                <span>{{provider.voffice_hours}}</span>
              </div>
              <div v-if="provider.phone">
                <include-svg svg :name="'icon-footer-phone'" />
                <span>Call us</span>
                <span>{{provider.phone}}</span>
              </div>
              <div v-if="provider.email">
                <include-svg svg :name="'icon-footer-mail'" />
                <span>Email us</span>
                <a 
                  :href="`mailto:${email}`"
                  class="sm-text"
                >{{email}}</a>
              </div>
            </div>
          </div>
        </div>
        <div class="sm-company-info__footer">
          <div class="sm-company-info__footer-left">
            <div v-if="provider.plan_layout && provider.plan_layout.description">{{provider.plan_layout.description}}</div>
            <div v-if="provider.plan_layout && provider.plan_layout.footer">{{provider.plan_layout.footer}}</div>
          </div>
          <a 
            :href="provider.website_url || '/'" 
            class="sm-company-info__footer-logo"
            target="_blank"
            rel="noreferrer"
          >
            <img-loader :src="logoUrl" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import imageStore from '@/utils/image-store';
import ImgLoader from '@/components/ImgLoader';
import Urls from '@/settings/urls';
import ProviderAddress from '@/mixins/ProviderAddress';

export default {
  name: 'company-info',
  components: {
    'img-loader': ImgLoader
  },
  data() {
    return {
      state: null
    };
  },
  created() {
    this.getStates();
  },
  computed: {
    ...mapGetters({
      provider: 'provider',
      countryList: 'countryList'
    }),
    logoUrl() {
      return imageStore(this.provider.image_url) || '';
    },
    email() {
      return this.provider.email || 'support@spheremail.co';
    },
    country() {
      return this.countryList.find(country => country.id == this.provider.country_id);
    }
  },
  mixins: [ProviderAddress],
  methods: {
    ...mapActions({
      getStateList: 'getStateList'
    }),
    getStates() {
      if (this.countryList.length && this.provider.country_id)
        this.getStateList(this.provider.country_id)
          .then(res => {
            if (this.country && this.country.states)
              this.state = this.country.states.find(state => state.id == this.provider.state_id);
          });
    },
    openMap() {
      let fullAddress = `${this.providerAddress.line_1} ${this.providerAddress.line_2} ${this.providerAddress.line_3}`;

      window.open(`${Urls.external.google_maps}${fullAddress}`, '_blank', {width: '100%'});
    }
  },
  watch: {
    countryList() {
      this.getStates();
    },
    provider() {
      this.getStates();
    }
  }
}
</script>

<style lang="scss">
  @use '@/assets/scss/general/mixins.scss' as *;
  @use '@/assets/scss/framework/scss-variables.scss' as *;
  @use '@/assets/scss/page-elements/_company-info.scss';
</style>
